
Greenmile.TrackEquipment = Greenmile.TrackEquipment || {};

Greenmile.TrackEquipment.CreateFilter = function () {

    this.createFilter = function () {

        if (this.form) {
            return;
        }

        var layout = {
            "userInterfaceAction": {
                "userInterface": {
                    "key": "TrackEquipment",
                    "description": "TrackEquipment"
                },
                "key": "list"
            },
            "sections": [
                {
                    "key": "pls_btn_code",
                    "description": " ",
                    "layoutColumns": 1,
                    "layoutOrder": 1,
                    "sectionRelatedLists": [],
                    "sectionFields": [],
                    "sectionButtons": [
                        {
                            "customLabel": "HOSMap.filter.btn.filterBtn",
                            "buttonOrder": 1,
                            "name": "btn_save"
                        },
                        {

                            "customLabel": "HOSMap.filter.btn.clearBtn",
                            "buttonOrder": 2,
                            "name": "btn_clear"
                        }
                    ]
                },
                {
                    "key": "pls_fields_trackequipment",
                    "description": "pls_fields_trackequipment",
                    "layoutColumns": 2,
                    "layoutOrder": 2,
                    "sectionRelatedLists": [],
                    "sectionFields": [
                        {

                            "sectionOrder": 1,
                            "formEvents": [],
                            "field": {
                                "name": "organization",
                                "label": "equipment.organization",
                                "type": "LOOKUP",
                                "mandatory": true,
                                "maxSize": 45,
                                "lookupEntityColumn": "description",
                                "lookupEntity": {
                                    "id": 10000,
                                    "key": "Organization"
                                }
                            },
                            "sectionColumn": 1
                        },
                        {
                            "sectionOrder": 2,
                            "field": {
                                "name": "key",
                                "label": (Monet.I18n.getResourcesByKey("equipment.key") + ' / ' + Monet.I18n.getResourcesByKey("default.description")),
                                "description": "description",
                                "type": "TEXT",
                                "maxSize": 45,
                                "lookupEntity": {}
                            },
                            "sectionColumn": 1
                        }
                    ],
                    "sectionButtons": []
                }
            ]
        };

        this.form = new Monet.Builder.Form.Vertical(layout, 'TrackEquipment');

        var formContainer = document.querySelector("#form_TrackEquipment");
        formContainer.appendChild(this.form.render());

        this.form.fields.key.input.id = 'trackEquipmentFilterKey';

        var grid = new Greenmile.TrackEquipment.Grid();
        grid.showGrid("TrackEquipmentMaps");

        Monet.I18n.translateInterface();
        this.addEventListener();

        App.Forms.TrackEquipmentMaps.form = this.form;
    };
    
    this.addEventListener = function () {

        var error = null;

        try {

            var actionSendForm = function (context) {
                return function () {
                    context.sendForm();
                };
            }(this);

            var buttons = this.form.buttons;

            var btnSave = buttons.btn_save;
            var btnClear = buttons.btn_clear;

            for (var i = 0; i < btnSave.length; i++) {
                btnSave[i].input.removeEventListener("click", actionSendForm);
                btnSave[i].input.addEventListener("click", actionSendForm);

                btnClear[i].input.removeEventListener("click", this.clearForm);
                btnClear[i].input.addEventListener("click", (function (scope) {
                    return function () {
                        scope.clearForm();
                        App.Views.TrackEquipmentMaps.clearEquipmentRoute({ removeEvents: true });
                    };
                }(this)));
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on add event to buttons.");
            error.console();

        }
    };

    this.clearForm = function () {

        if (this.form) {
            var fields = this.form.fields;
            fields.organization.clear();
            fields.key.clear();
        }
        this.clearGrid();
    };

    this.clearGrid = function () {
        var grid = new Greenmile.TrackEquipment.Grid();
        grid.clear('TrackEquipmentMaps');
    };

    this.sendForm = function () {
        App.Forms.TrackEquipmentMaps.pagination.first = 0;
        var filter = this.getValuesAndFormatJson();

        var request = new Greenmile.TrackEquipment.Request();
        request.getEquipments(filter, Monet.Grid.addDataToGrid);
    };

    this.getValuesAndFormatJson = function () {

        var error = null;

        try {

            var fields = App.Forms.TrackEquipmentMaps.form.fields;
            var keyValue = fields.key.getValue();
            var filterObj = {
                organization: {},
                key: {},
                description: {}
            };
            filterObj.organization = fields.organization.getValue();

            filterObj.key = {
                id: keyValue
            };

            filterObj.description = {
                id: keyValue
            };

            return filterObj;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on clear form hos maps.", e);
            error.console();
        }
    };

    App.Forms.TrackEquipmentMaps.createFilter = this;
};

